module.exports = __webpack_public_path__ + "static/media/197.42f10bc4.wav";